@if (model()) {
  <form [formGroup]="formGroup" class="row gap-md-0 gap-4">
    <div class="col-12 col-md-6">
      <div class="row gap-4">
        <div class="col-sm-12"><h5 class="m-0">{{ 'CUSTOMERS.SALES' | translate }}</h5></div>
        <!-- SALESPERSON -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpUserId'"
                          [formGroup]="formGroup"
                          [id]="'erpUserId'"
                          [label]="'CUSTOMERS.SALESPERSON'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="erpUserService"></app-api-select>
        </div>
        <!-- PAYMENT TERM (SALE) -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpPaymentTermId'"
                          [formGroup]="formGroup"
                          [id]="'erpPaymentTermId'"
                          [label]="'CUSTOMERS.PAYMENT_TERM'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="paymentTermService"></app-api-select>
        </div>
        <!-- PRICELIST -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpPricelistId'"
                          [formGroup]="formGroup"
                          [id]="'erpPricelistId'"
                          [label]="'CUSTOMERS.PRICELIST'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="pricelistService"></app-api-select>
        </div>
        <!-- FISCAL POSITION -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpFiscalPositionId'"
                          [formGroup]="formGroup"
                          [id]="'erpFiscalPositionId'"
                          [label]="'CUSTOMERS.FISCAL_POSITION'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="fiscalPositionService"></app-api-select>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <div class="row gap-4">
        <div class="col-sm-12"><h5 class="m-0">{{ 'CUSTOMERS.PURCHASE' | translate }}</h5></div>
        <!-- BUYER -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpBuyerId'"
                          [formGroup]="formGroup"
                          [id]="'erpBuyerId'"
                          [label]="'CUSTOMERS.BUYER'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="erpUserService"></app-api-select>
        </div>
        <!-- SUPPLIER PAYMENT TERM -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpSupplierPaymentTermId'"
                          [formGroup]="formGroup"
                          [id]="'erpSupplierPaymentTermId'"
                          [label]="'CUSTOMERS.SUPPLIER_PAYMENT_TERM'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="paymentTermService"></app-api-select>
        </div>
        <!-- PURCHASE CURRENCY -->
        <div class="col-sm-12">
          <app-api-select [controlName]="'erpPurchaseCurrencyId'"
                          [formGroup]="formGroup"
                          [id]="'erpPurchaseCurrencyId'"
                          [label]="'CUSTOMERS.PURCHASE_CURRENCY'"
                          [optionLabelSelector]="[{ selector: 'name' }]"
                          [optionValueSelector]="'id'"
                          [queryParams]="emptyQueryParams"
                          [searchService]="currencyService"></app-api-select>
        </div>
        <!-- RECEIPT REMINDER -->
        <div class="col-sm-12">
          <app-checkbox-input [controlName]="'receiptReminderEmail'"
                              [formGroup]="formGroup"
                              [id]="'receiptReminderEmail'"
                              [label]="('CUSTOMERS.RECEIPT_REMINDER_EMAIL'|translate)"></app-checkbox-input>
        </div>
        @if (formGroup.get('receiptReminderEmail')?.value) {
          <div class="col-sm-12">
            <app-form-input [controlName]="'reminderDateBeforeReceipt'"
                            [formGroup]="formGroup"
                            [id]="'reminderDateBeforeReceipt'"
                            [label]="'CUSTOMERS.REMINDER_DAYS_BEFORE_RECEIPT'"
                            [type]="'number'"
                            [min]="0"></app-form-input>
          </div>
        }
      </div>
    </div>
  </form>
  <div class="d-flex justify-content-end align-items-center mt-4">
    <app-mdb-button (onClick)="submit()" [loading]="loading" [text]="'SAVE'"></app-mdb-button>
  </div>
} @else {
  <app-spinner></app-spinner>
}
